import styles from './adBrand.scss';
import { BhImage } from 'models/BhImage';
import Image from 'components/Shared/Image';
import cn from 'classnames';
import ResponsiveImage from 'components/Shared/Image/ResponsiveImage';
import { SrcSet } from 'components/Shared/Image/SrcSet';

interface AdBrandProps extends BhImage {
  size: 'large' | 'small';
  position: 'top' | 'bottom';
}

const MOBILE_WIDTH = 72;
const DESKTOP_WIDTH = 142;

const sizes: Record<'small' | 'large', { width: number; height: number }> = {
  large: { width: 142, height: 71 },
  small: { width: 72, height: 36 }
};

const customSizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

const responsive: ResponsiveImage = {
  srcSet: Object.values(customSizes),
  sizes: `(max-width: 768px) ${customSizes.default.width}px,
  ${customSizes.medium.width}px`
};

export const AdBrand = ({ size, position, ...props }: AdBrandProps) => (
  <Image
    className={cn(styles.adBrand, {
      [styles.top]: position === 'top',
      [styles.bottom]: position === 'bottom',
      [styles.large]: size === 'large',
      [styles.small]: size === 'small'
    })}
    {...props}
    {...sizes[size]}
    responsive={responsive}
  />
);
